import { render } from "./AdminButton.vue?vue&type=template&id=19208cee"
import script from "./AdminButton.vue?vue&type=script&lang=js"
export * from "./AdminButton.vue?vue&type=script&lang=js"
script.render = render

export default script